export const CUSTOM_FONT_STYLE_NAME = 'dynamic-font-family-style';
export const ThUMB_CUSTOM_FONT_STYLE_NAME = 'dynamic-thumb-font-family-style';

export const BG_COLOR = 'color';
export const BG_IMAGE = 'image';

export const TEXT_TYPE = 'text';
export const IMAGE_TYPE = 'image';

export const DEFAULT_FONT_SIZE = 30;
export const DEFAULT_FONT_COLOR = '#9d9797';
export const DEFAULT_BG_COLOR = '#ffffff';
export const DEFAULT_ALIGNMENT = 'center';
export const DEFAULT_RACT_POSITION = 'top';
export const DEFAULT_DRAG_IMAGE_WIDTH = 500;
export const DEFAULT_DRAG_IMAGE_HEIGHT = 333;
export const TEXT_PADDING = 80; // Change this for text padding

export const FIRST_PHOTO = 'first';
export const SELECTED_PHOTO = 'selected';
export const ALL_PHOTOS = 'all';

export const DEFAULT_BANNER = 'default';
export const IMAGE_BANNER = 'image';

export const VIDEO_BILLBOARD = 'video';
export const IMAGE_BILLBOARD = 'image';
export const DEFAULT_BILLBOARD = 'default';

export const DEFAULT_DURATION = 'Automatic';
export const INDEFINITE_DURATION = 'Indefinite';
export const DAYS_DURATION = 'Days';

export const RESOLUTION_3x2 = { width: 1536, height: 1024 };
export const RESOLUTION_4x3 = { width: 1600, height: 1200 };
export const RESOLUTION_YT_3x2 = { width: 1536, height: 864 };
export const RESOLUTION_YT_4x3 = { width: 1600, height: 900 };

export const THUMB_DEFAULT_STARTX = 150;
export const THUMB_DEFAULT_STARTY = 100;

export const photoOperators = [
  { value: '<', label: 'Less Than' },
  { value: '>', label: 'More Than' },
  { value: '=', label: 'Equals To' }
];

export const ageOperators = [
  { value: '<', label: 'Less Than' },
  { value: '>', label: 'More Than' }
];

export const durationTypeList = [
  {
    value: DEFAULT_DURATION,
    label: 'Automated banner application/removal'
  },
  { value: INDEFINITE_DURATION, label: 'No End Date' },
  { value: DAYS_DURATION, label: 'Default Banner for New Listings' }
  // { value: MULTI_BANNER_DURATION, label: 'Mutliple banners' }
];

export const billboardDurationTypeList = [
  {
    value: DEFAULT_DURATION,
    label: 'Automated billboard addition/removal'
  },
  { value: INDEFINITE_DURATION, label: 'No End Date' },
  { value: DAYS_DURATION, label: 'Default Billboard for New Listings' }
];
